import { render, staticRenderFns } from "./ShibouDoukishoPreview.vue?vue&type=template&id=0cacece4"
import script from "./ShibouDoukishoPreview.vue?vue&type=script&lang=js"
export * from "./ShibouDoukishoPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports